import React from "react";
import "../styles/forms.css";
import {
  getPerfil,
  getDataFrm,
  axEliminarConocimiento,
  axSaveEditConocimiento,
} from "../requests/req_perfil";
import Swal from "sweetalert2";
import {
  Col,
  Button,
  FormGroup,
  UncontrolledTooltip,
} from "reactstrap";
import { getUser, notifica } from "../requests/utils";
import { getNivelesConocimiento } from "../requests/CatalogosGenerales";
import { postInsertarConocimiento } from "./../requests/PerfilCandidato";

export default class FrmConocimientos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: this.props.datos,
      edit: false,
      nivelesConocimiento: [],
    };
    this.guardarInf = this.guardarInf.bind(this);
    this.generaBarras = this.generaBarras.bind(this);
    this.editarAgregar = this.editarAgregar.bind(this);
    this.editCloseForm = this.editCloseForm.bind(this);
    this.validarCampos = this.validarCampos.bind(this);
  }
  componentDidMount() {
    if (localStorage.getItem("frmCncmnt") != null) {
      this.editCloseForm(localStorage.getItem("frmCncmnt"));
    }
    getPerfil((p) => this.asignaValores(p));
    getNivelesConocimiento().then((res) => {
      this.setState({ nivelesConocimiento: res });
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
    var json = getDataFrm(".frmCncmnt");
    if (
      JSON.parse(json).idConocimiento !== "" &&
      JSON.parse(json).idNivel !== ""
    )
      localStorage.setItem("frmCncmnt", json);
    else localStorage.removeItem("frmCncmnt");
  }
  editCloseForm(datos) {
    if (datos != null) {
      var Items = JSON.parse(datos);
      var txtinpCon = document.getElementById("inpCon");
      var cmbNvl = document.getElementById("inpNiv");
      txtinpCon.value = Items.idConocimiento;
      cmbNvl.value = Items.idNivel;

      var 
        d = document.getElementById("dv_EditarConocimiento"),
        btnAdd = document.getElementById("btn_conoc_add"),
        btnSve = document.getElementById("btn_conoc_guardar");

      d.classList.remove("Hide_All");
      btnAdd.classList.add("Hide_All");
      btnSve.classList.remove("Hide_All");
    }
  }
  generaBarras(datos) {
    const { edit } = this.state;
    if (!datos) return null;
    return datos.map((d, index) => {

      return (
        <div className="col-md-12 row" key={index}>
          <div className="col-md-10">
            <p id="conocimiento">{d.conocimiento + " - " + d.nivel}</p>
          </div>
          <div className="col-md-1">
            <img
              src={window.origin + "/images/icon_edit_1.png"}
              alt="alternative text"
              title="Editar"
              idconocimiento={d.idConocimiento}
              descon={d.conocimiento}
              idnivel={d.idNivel}
              style={{ width: "25px" }}
              niv={d.nivel}
              onClick={(e) => this.editarAgregar(e)}
            />
          </div>
          <div className="col-md-1">
            <img
              alt="alternative text"
              title="Eliminar"
              style={{ width: "25px", height: "25px" }}
              src={window.origin + "/images/icon_delete_1.png"}
              className={`eliminar-conocimiento ${edit ? "d-none" : ""}`}
              onClick={(e) => this.eliminarConocimiento(d, e)}
            />
          </div>
        </div>
      );
    });
  }

  eliminarConocimiento(datos, e) {
    Swal.fire({
      title: "¿Estas seguro que deseas eliminar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        axEliminarConocimiento(
          getUser().idCandidato,
          datos.idConocimiento
        ).then((valor) => {
          getPerfil((p) => this.asignaValores(p));
        });
      }
    });
  }

  editarAgregar(e) {
    var elm = e.target,
      idCconom = document.getElementsByClassName("idConocimientoEdit"),
      lbl = document.getElementById("lbl_IdConocimiento"),
      d = document.getElementById("dv_EditarConocimiento"),
      btnAdd = document.getElementById("btn_conoc_add"),
      btnSve = document.getElementById("btn_conoc_guardar"),
      inpDec = document.getElementById("inpCon"),
      inpNiv = document.getElementById("inpNiv");

    if (elm.type !== undefined) {
      lbl.innerText = 0;
      inpDec.value = "";
      inpNiv.value = 0;
    } else {
      var dv = elm;
      var idC = dv.getAttribute("idconocimiento");
      var desc = dv.getAttribute("descon");
      var niv = dv.getAttribute("idnivel");
      lbl.innerText = parseInt(idC, 10);
      inpDec.value = desc;
      inpNiv.value = niv;
    }
    this.setState({ edit: true });
    idCconom[0].setAttribute("id", idC);
    d.classList.remove("Hide_All");
    btnAdd.classList.add("Hide_All");
    btnSve.classList.remove("Hide_All");
  }

  guardarInf(e) {
    if (!this.validarCampos()) return;

    const { handleUpdate } = this.props;
    let idConocimiento = document
      .getElementsByClassName("idConocimientoEdit")[0]
      .getAttribute("id");

    if (
      idConocimiento === null ||
      idConocimiento === "null" ||
      idConocimiento === "" ||
      idConocimiento === undefined ||
      idConocimiento === "undefined"
    ) {
      //si tiene valor entonces es un registro nuevo
      var json = getDataFrm(".frmCncmnt");
      let data = JSON.parse(json);
      let parsedData = {
        IdCandidato: data.idCandidato,
        Conocimiento: data.idConocimiento,
        IdNivel: data.idNivel,
      };
      postInsertarConocimiento(parsedData).then((res) => {
        handleUpdate && handleUpdate();

        getPerfil((p) => this.asignaValores(p));
      });

      var elm = e.target,
        lbl = document.getElementById("lbl_IdConocimiento"),
        d = document.getElementById("dv_EditarConocimiento"),
        btnAdd = document.getElementById("btn_conoc_add"),
        btnSve = document.getElementById("btn_conoc_guardar"),
        inpDec = document.getElementById("inpCon"),
        inpNiv = document.getElementById("inpNiv");
      if (elm.type !== undefined) {
        lbl.innerText = 0;
        inpDec.value = "";
        inpNiv.value = 0;
      } else {
        var dv = elm.classList.contains("progress") ? elm : elm.parentElement,
          idC = dv.getAttribute("idconocimiento"),
          desc = dv.getAttribute("descon"),
          niv = dv.getAttribute("idnivel");
        lbl.innerText = parseInt(idC, 10);
        inpDec.value = desc;
        inpNiv.value = niv;
      }
      d.classList.add("Hide_All");
      btnAdd.classList.remove("Hide_All");
      btnSve.classList.add("Hide_All");
      this.setState({ edit: false });
      getPerfil((p) => this.asignaValores(p));
      var btnrefresh = document.getElementById("btnrefresh");
      if (btnrefresh) btnrefresh.click();
    } else {
      this.guardarConocimientosEdit(
        idConocimiento,
        document.getElementById("inpNiv").value,
        document.getElementById("inpCon").value,
        e.target
      );
    }
  }

  guardarConocimientosEdit(idConocimiento, nivel, conocimiento, e) {

    var json = getDataFrm(".frmCncmnt");
    let data = JSON.parse(json);

    axSaveEditConocimiento(
      data.idCandidato,
      idConocimiento,
      nivel,
      conocimiento
    ).then((valor) => {
      //se limpia id para identificar que ya no va a editar el registro
      document
        .getElementsByClassName("idConocimientoEdit")[0]
        .setAttribute("id", "");

      var elm = e,
        lbl = document.getElementById("lbl_IdConocimiento"),
        d = document.getElementById("dv_EditarConocimiento"),
        btnAdd = document.getElementById("btn_conoc_add"),
        btnSve = document.getElementById("btn_conoc_guardar"),
        inpDec = document.getElementById("inpCon"),
        inpNiv = document.getElementById("inpNiv");
      if (elm.type !== undefined) {
        lbl.innerText = 0;
        inpDec.value = "";
        inpNiv.value = 0;
      } else {
        var dv = elm.classList.contains("progress") ? elm : elm.parentElement,
          idC = dv.getAttribute("idconocimiento"),
          desc = dv.getAttribute("descon"),
          niv = dv.getAttribute("idnivel");
        lbl.innerText = parseInt(idC, 10);
        inpDec.value = desc;
        inpNiv.value = niv;
        getPerfil((p) => this.asignaValores(p));
      }
      d.classList.add("Hide_All");
      btnAdd.classList.remove("Hide_All");
      btnSve.classList.add("Hide_All");
      this.setState({ edit: false });
      getPerfil((p) => this.asignaValores(p));
    });
  }

  validarCampos() {
    var i = 0;
    var inpNiv = document.getElementById("inpNiv");
    var inpCon = document.getElementById("inpCon");
    if (inpNiv.value === "0" || inpNiv.value == null) {
      if (inpCon.value === "" || inpCon.value == null) {
        notifica("warning", "Todos los campos son obligatorios", "Alerta!");
        i++;
      } else {
        notifica("warning", "Debe de indicar un Nivel", "Alerta!");
        i++;
      }
    } else {
      if (inpCon.value === "" || inpCon.value == null) {
        notifica("warning", "El campo Conocimiento es obligatorio", "Alerta!");
        i++;
      }
    }

    if (inpCon.value.length > 250) {
      notifica(
        "warning",
        "El campo Conocimiento no debe contener más de 250 caracteres",
        "Alerta!"
      );
      i++;
    }
    if (i > 0) return false;
    else return true;
  }
  asignaValores(res) {
    if (res === null || res === undefined) return;
    if (res?.tabla3?.length > 0) {
      this.setState({
        datos: res.tabla3,
      });
      var btnrefresh = document.getElementById("btnrefresh");
      if (btnrefresh) btnrefresh.click();
    }
    this.generaBarras(this.state.datos);
  }

  render() {
    return (
      <div className="APL_Frm_dv idConocimientoEdit" id="">
        <FormGroup
          className="Hide_All dv_Form_New_Edit"
          id="dv_EditarConocimiento"
          row
        >
          <label id="lbl_IdConocimiento" className="Hide_All"></label>
          <Col sm={4} md={4} lg={4}>
            {" "}
            <label className="lbl_md">
              Conocimiento:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={8} md={8} lg={8}>
            <input
              type="text"
              className="frm frmCncmnt"
              datsvfrm="idConocimiento"
              id="inpCon"
            />
          </Col>
          <Col sm={4} md={4} lg={4}>
            {" "}
            <label className="lbl_md">
              Nivel:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={8} md={8} lg={8}>
            <select className="frm frmCncmnt" datsvfrm="idNivel" id="inpNiv">
              <option value="0">Selecciona...</option>
              {this.state.nivelesConocimiento.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={9} md={9} lg={9}></Col>
          <Col sm={3} md={3} lg={3}>
            <Button
              outline
              color="success"
              className="btn_exp_add"
              id="btn_conoc_add"
              idexperiencia={0}
              onClick={(e) => this.editarAgregar(e)}
            >
              <img
                src={window.origin + "/images/icon_add_2.png"}
                className="img_edit"
                alt="Agregar"
              />
              Agregar Conocimiento
            </Button>
            <Button
              outline
              color="info"
              className="btn_exp_add Hide_All"
              alt="Guardar"
              id="btn_conoc_guardar"
              idexperiencia={0}
              onClick={(e) => this.guardarInf(e)}
            >
              <img
                src={window.origin + "/images/icon_save_2.png"}
                className="img_edit "
                alt=""
              />
              Guardar Cambios
            </Button>

            <UncontrolledTooltip placement="right" target="btn_conoc_guardar">
              Guardar Cambios
            </UncontrolledTooltip>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12} md={12} lg={12}>
            {this.generaBarras(this.state.datos)}
          </Col>
        </FormGroup>
      </div>
    );
  }
}
